export enum LabelTypes {
  NORMAL_LABEL = 'NORMAL_LABEL',
  SUMMARY_LABEL = 'SUMMARY_LABEL',
  BLOCK_LABEL = 'BLOCK_LABEL',
  CC_UPDATE_LABEL = 'CC_UPDATE_LABEL',
  EXCEPTION_LABEL = 'EXCEPTION_LABEL',
  CC_EXCEPTION_LABEL = 'CC_EXCEPTION_LABEL',
}
